// @flow
import React, { memo } from 'react';
import { GridCell } from 'Components/frameworks/grid-cell/Grid.cell.jsx';
import { GridRow } from 'Components/frameworks/grid-row/Grid.row.jsx';
import { CriteriaControls } from './CriteriaControls';
import { CallCenterBlock } from './CallCenterBlock';

type Props = {
  title: string,
  explanation: string,
};

export const SearchNoResults = memo<Props>(({ explanation, title }: Props) => (
  <GridRow className="text-center md:text-initial">
    <GridCell cols={{ M: 7, XS: 12 }}>
      <div className="my-4 lg:my-6">
        <p className="my-4 font-brand text-md md:text-xl lg:text-2xl">{title}</p>
        <p>{explanation}</p>
        <CriteriaControls />
      </div>
    </GridCell>
    <GridCell cols={{ M: 5, XS: 12 }}>
      <div className="my-4 lg:my-6">
        <CallCenterBlock />
      </div>
    </GridCell>
  </GridRow>
));
